import React from "react";
import { useDateTimeFormatter } from "src/shared/configurations/hooks/useDateTimeFormatter";

interface Props {
  roundValue: (val: number) => number;
  totalAmount: number;
  discount: number;
  ledgerDiscount: number;
  deliveryFee: number;
  finalAmount: number;
  receivedBalance: number;
  remaining: number;
  AdvanceAmount: number;
  outstandingAmount: number;
  paymentMethod: string;
  orderDate: string;
  orderTime: string;
  deliveryFeeEnabled: boolean;
}

const OrderPriceDetails: React.FC<Props> = ({
  roundValue,
  totalAmount,
  discount,
  ledgerDiscount,
  deliveryFee,
  finalAmount,
  receivedBalance,
  remaining,
  AdvanceAmount,
  outstandingAmount,
  paymentMethod,
  orderDate,
  orderTime,
  deliveryFeeEnabled,
}) => {
  const { formatDate, formatTime } = useDateTimeFormatter();
  const renderDetail = (label: string, value: string | number) => (
    <div className="flex justify-between px-2.5 my-2">
      <h2>{label}</h2>
      <h2 className="font-semibold">{value}</h2>
    </div>
  );

  // Clear name for final calculated bill total is totalAmount - discount 
  const netAmount = finalAmount - ledgerDiscount;
  
  const showAdvanceAmount = AdvanceAmount !== undefined && AdvanceAmount !== null && AdvanceAmount !== 0;
  // const showLedgerDiscount = ledgerDiscount !== undefined &&  ledgerDiscount !== null && ledgerDiscount !== 0;

  return (
    <div className="h-auto shadow-md rounded-lg bg-white">
      {renderDetail("Sub total", roundValue(totalAmount).toFixed(2))}
      {renderDetail("Discount (-)", roundValue(discount).toFixed(2))}
      {deliveryFeeEnabled && renderDetail("Delivery Fee (+)", roundValue(deliveryFee).toFixed(2))}
      {renderDetail("Total Amount", roundValue(netAmount).toFixed(2))}
      {renderDetail("Received Amount", roundValue(receivedBalance).toFixed(2))}
      {/* {showLedgerDiscount && renderDetail("Ledger discount (-)", roundValue(ledgerDiscount).toFixed(2))} */}
      {/* Conditionally render Advance Amount */}
      {showAdvanceAmount && renderDetail("Advance Amount (-)", roundValue(AdvanceAmount).toFixed(2))}
      {renderDetail("Remaining balance", roundValue(remaining).toFixed(2))}
      {renderDetail("Outstanding balance", roundValue(outstandingAmount).toFixed(2))}
      {renderDetail("Payment mode", paymentMethod)}
      {renderDetail("Order date & time", `${formatDate(orderDate)} & ${formatTime(orderTime)}`)}
      {/* {renderDetail("Order time", orderTime)} */}
    </div>
  );
};

export default OrderPriceDetails;